import type { Theme } from 'hephaestus/core';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { BORDERED_BOX_SX, SECTION_HEADER_SX, VALUE_ROW_SX } from '../styles';
import type { GeneralInfoRow } from '../utils/portfolioRevampBuilders';
export type PortfolioRowDetailGeneralInfoProps = {
  generalInfoRows: GeneralInfoRow[];
  theme: Theme;
};

export const PortfolioRowDetailGeneralInfo = ({
  generalInfoRows,
  theme,
}: PortfolioRowDetailGeneralInfoProps) => {
  const { t } = useTranslation('portfolioTradingHub');

  return (
    <Box
      sx={{
        ...BORDERED_BOX_SX,
        bgcolor: theme.color.surface,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography variant='labelSmall' sx={SECTION_HEADER_SX}>
        {t('rowDetail.generalInfo.title')}
      </Typography>
      {generalInfoRows.map((row) => (
        <Box
          key={row.label}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant='bodySmall'
            sx={{ color: theme.color.onSurfaceVariant }}
          >
            {row.label}
          </Typography>
          <Typography
            variant='bodySmall'
            sx={{ ...VALUE_ROW_SX, color: row.color }}
          >
            {row.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
